import { Autocomplete, Button, Grid, IconButton, TextField, Tooltip, Typography } from "@mui/material"
import { useEffect, useState } from "react"

//assets
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import SearchIcon from '@mui/icons-material/Search'
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop"
import { ApiStatus } from "../../types/api/status"
import { Month } from "../../types/slices/monthType"
import { Year } from "../../types/slices/yearType"
import { CustomSnackbar } from "../../components/common/CustomSnackbar/CustomSnackbar"
import { Rendition } from "../../types/slices/renditionType"
import { useBuildingStore } from "../../hooks/useBuildingStore"
import { Building } from "../../types/slices/buildingType"
import { useRenditionBuildingStore } from "../../hooks/useRenditionBuildingStore"
import { RenditionBuildingAddCostModal } from "./components/RenditionBuildingAddCostModal"
import { RenditionBuildingTableDetail } from "./components/RenditionBuildingTableDetail"
import { useNavigate } from "react-router-dom"
import { RoutesMap } from "../../types"
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import '../../assets/styles/pewen-app.css'
import { usePeriodStore } from "../../hooks/usePeriodStore"
import { useRenditionBuildingSpentStore } from "../../hooks/useRenditionBuildingSpentStore"
import { MonthPickerButton } from "../../components/common/MonthPickerButton/MonthPickerButton"
import SyncIcon from '@mui/icons-material/Sync'

const months = [
    { id: 1, name: 'Enero' },
    { id: 2, name: 'Febrero' },
    { id: 3, name: 'Marzo' },
    { id: 4, name: 'Abril' },
    { id: 5, name: 'Mayo' },
    { id: 6, name: 'Junio' },
    { id: 7, name: 'Julio' },
    { id: 8, name: 'Agosto' },
    { id: 9, name: 'Setiembre' },
    { id: 10, name: 'Octubre' },
    { id: 11, name: 'Noviembre' },
    { id: 12, name: 'Diciembre' },
]

export const RenditionBuildingOpen = (props) => {
    const navigate = useNavigate()

    const { status: renditionBuildingStatus, selectedRenditionBuilding, renditionBuildings, setSelectedRenditionBuilding, getOrCreateRendition } = useRenditionBuildingStore()
    const { insertBeforeSpent } = useRenditionBuildingSpentStore();
    const { status: statusBuildingAPI, buildings, selectedBuilding, getBuildings, setSelectedBuilding } = useBuildingStore();
    const [isCreate, setIsCreate] = useState<boolean>(false)
    const [showModal, setShowModal] = useState<boolean>(false)
    const { getPeriods, periods } = usePeriodStore();
    const [availableYears, setAvailableYears] = useState<Year[]>([]);
    const [selectedDate, setSelectedDate] = useState<Date>(new Date())
    const selectedMonth = selectedDate.getMonth() + 1
    const selectedYear = selectedDate.getFullYear()

    useEffect(() => {
        getDataInitial();
    }, [])

    const getDataInitial = async () => {
        await getPeriods()
        await getBuildings()
    }

    useEffect(() => {
        if (periods && periods.length > 0) {
            const uniqueYears = Array.from(new Set(periods.map((p: any) => p.year)))
                .map(year => ({ id: year, name: year.toString() }));
            setAvailableYears(uniqueYears);
        }
    }, [periods])

    useEffect(() => {
        if (!selectedRenditionBuilding && buildings.length > 0) {
            setSelectedBuilding(buildings[0])
        }
    }, [buildings])

    useEffect(() => {
        if (selectedRenditionBuilding?.idbuilding && buildings.length > 0) {
            const building = buildings.find(item => item.id === selectedRenditionBuilding.idbuilding)
            setSelectedBuilding(building || {} as Building)
        }
    }, [selectedRenditionBuilding, buildings])

    useEffect(() => {
        validateIsEdit()
    }, [availableYears])

    const handleOpenRendition = async () => {
        if (!selectedBuilding.id) return CustomSnackbar('error', 'Seleccione un edificio')

        const response = await getOrCreateRendition({
            month: selectedMonth,
            year: selectedYear,
            idbuilding: selectedBuilding.id
        });
        if (response === true) setIsCreate(true)
    }

    const closeRendition = () => {
        setIsCreate(false)
        setSelectedBuilding({} as Building)
    }

    const validateIsEdit = async () => {
        if (selectedRenditionBuilding && Object.entries(selectedRenditionBuilding).length > 0) {

            const date = new Date(parseInt(selectedRenditionBuilding.year), parseInt(selectedRenditionBuilding.month) - 1)
            setSelectedDate(date)

            await getOrCreateRendition({
                month: selectedRenditionBuilding.month,
                year: selectedRenditionBuilding.year,
                idbuilding: selectedRenditionBuilding.idbuilding
            })
            await setIsCreate(true)
        }
    }

    const getRenditionBefore = async () => {
        await insertBeforeSpent(renditionBuildings[0].id)
        await getOrCreateRendition({
            month: selectedMonth,
            year: selectedYear,
            idbuilding: renditionBuildings[0].idbuilding
        })
    }

    return (
        <Grid container>
            {statusBuildingAPI === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            {renditionBuildingStatus === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            {
                isCreate && (
                    <Grid item xs={12} display='flex' alignItems='center'>

                        <Grid className="btn-back-container" onClick={() => closeRendition()}>
                            <IconButton id="back" size="small" aria-label="view" >
                                <ArrowCircleLeftIcon fontSize='small' sx={{ color: '#188dcd' }} />
                            </IconButton>
                            <Typography className='btn-back-text'>Volver</Typography>
                        </Grid>

                    </Grid>
                )
            }
            <Grid item container sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '20px' }}>
                <Typography variant='h6' component='h1' gutterBottom color='#808080' className="tittle" sx={{ mt: 1, ml: 1, fontWeight: 600 }}>
                    APERTURA DE RENDICIONES PARA EDIFICIO
                </Typography>
            </Grid>
            <Grid
                item
                container
                xs={12}
                justifyContent="center"
                alignItems="center"
                spacing={2}
                sx={{
                    border: '1px solid #e9e2e2',
                    borderRadius: '10px',
                    padding: 2,
                }}
            >
                {/* Autocomplete de edificios */}
                <Grid item>
                    <Autocomplete
                        id="combo-box-department"
                        size="small"
                        disabled={isCreate}
                        value={selectedBuilding}
                        options={buildings || []}
                        getOptionLabel={(option) => option.name || ""}
                        isOptionEqualToValue={(option, value) => option?.name === value?.name}
                        sx={{ width: 250 }}
                        renderInput={(params) => (
                            <TextField {...params} label="Edificios" size="small" />
                        )}
                        onChange={(e, newValue) => {
                            setSelectedBuilding(newValue || ({} as Building))
                        }}
                    />
                </Grid>

                {/* Selector de mes */}
                <Grid item>
                    <MonthPickerButton
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        disabled={isCreate}
                    />
                </Grid>

                {/* Botones según estado */}
                {!isCreate ? (
                    <Grid item>
                        <Button
                            onClick={handleOpenRendition}
                            size="small"
                            variant="contained"
                            sx={{
                                fontSize: "0.75rem",
                                fontWeight: "medium",
                                textTransform: "none",
                                color: "#fff",
                                px: 2,
                                py: 1.35,
                                borderRadius: 3,
                                background: "#212D39",
                                '&:hover': {
                                    background: '#212D39',
                                    color: '#fff',
                                },
                            }}
                        >
                            Crear apertura
                        </Button>
                    </Grid>
                ) : (
                    <>
                        <Grid item>
                            <Button
                                onClick={() => setShowModal(true)}
                                startIcon={<SearchIcon />}
                                sx={{
                                    fontSize: "0.75rem",
                                    fontWeight: "medium",
                                    textTransform: "none",
                                    color: "#fff",
                                    px: 2,
                                    py: 1.35,
                                    borderRadius: 3,
                                    background: "#212D39",
                                    '&:hover': {
                                        background: '#212D39',
                                        color: '#fff',
                                    },
                                }}
                            >
                                Agregar gasto
                            </Button>
                        </Grid>
                        <Grid item>
                            <Tooltip title="Traer gastos de rendición anterior">
                                <Button
                                    onClick={getRenditionBefore}
                                    sx={{
                                        fontSize: "0.75rem",
                                        fontWeight: "medium",
                                        textTransform: "none",
                                        color: "#fff",
                                        px: 2,
                                        py: 1.35,
                                        borderRadius: 3,
                                        background: "#212D39",
                                        '&:hover': {
                                            background: '#212D39',
                                            color: '#fff',
                                        },
                                    }}
                                    startIcon={<SyncIcon />}
                                >
                                    Anterior
                                </Button>
                            </Tooltip>
                        </Grid>
                    </>
                )}
            </Grid>

            <Grid item container xs={10} sx={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '20px' }}>
                {
                    !isCreate
                        ?
                        <Grid item xs={12}>
                            <Typography></Typography>
                            {/* <Typography sx={{ fontWeight: 'bolder' }}>
                        Consejos de la aplicación:
                    </Typography>
                    <Typography sx={{ textAlign: 'justify', margin: '10px 0px'}}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vitae cursus lectus. Cras condimentum mi eget lectus fermentum interdum. Fusce non blandit dolor. Etiam viverra felis enim, sed aliquam quam mollis sit amet. Nulla a finibus mauris. Proin dignissim aliquet feugiat. Aliquam enim orci, tristique aliquet interdum id, dapibus a nibh. Interdum et malesuada fames ac ante ipsum primis in faucibus. Pellentesque placerat, augue et tincidunt rhoncus, nisl nunc bibendum urna, in semper ipsum diam non risus. Donec eget ligula id ante dignissim ornare. Sed blandit dui augue, eget venenatis magna consectetur nec. Quisque in lorem vitae sapien finibus interdum. Aliquam erat volutpat. Sed eget velit vitae eros gravida tempus.
                    </Typography> */}
                        </Grid>
                        :
                        <RenditionBuildingTableDetail
                            handleBack={closeRendition}
                            confirm={() => { navigate({ pathname: RoutesMap.RENDITION_ADMIN_BUILDING_LIST }, { replace: true }) }}
                            buildingSelected={selectedBuilding}
                        />
                }
            </Grid>
            {
                showModal && (
                    <RenditionBuildingAddCostModal
                        open={showModal}
                        edit={false}
                        closeModal={() => setShowModal(false)}
                        buildingSelected={selectedBuilding}
                        monthSelected={selectedMonth}
                        yearSelected={selectedYear}
                    />
                )
            }
        </Grid>
    )
}